var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlechaLinealArriba24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43007 11.7999C4.70007 12.1099 5.17007 12.1499 5.49007 11.8799L11.2501 6.93994L11.2501 18.3099C11.2501 18.7199 11.5901 19.0599 12.0001 19.0599C12.4101 19.0599 12.7501 18.7199 12.7501 18.3099L12.7501 6.93994L18.5101 11.8799C18.8201 12.1499 19.3001 12.1099 19.5701 11.7999C19.8401 11.4899 19.8001 11.0099 19.4901 10.7399L13.2701 5.40994C12.9001 5.08994 12.4501 4.93994 12.0001 4.93994C11.5501 4.93994 11.1001 5.09994 10.7301 5.40994L4.51007 10.7399C4.20007 11.0099 4.16007 11.4799 4.43007 11.7999Z",
    fill: "#42C67E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaLinealArriba24X24);
export default __webpack_public_path__ + "static/media/FLECHA_LINEAL_ARRIBA_24X24.d3f9404f4b968b3dcc377d527c2cd5f5.svg";
export { ForwardRef as ReactComponent };